module.exports = __webpack_public_path__ + "img/FTC.9ca27799.svg";